module.exports = __webpack_public_path__ + "static/media/rtsp_splash_1.9ffd6642.png";